/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import useRequestSelectionBoxes from './request-selection-boxes.composable';

import { LocationSuggestion } from '../graphql/schema';

const useRequestSessionStorage = () => {
  const WINDOW_SESSION_SELECTED_LOCATION = 'request.confirmed.selectedLocation';
  const WINDOW_SESSION_SELECTED_RETAILER = 'request.confirmed.selectedRetailer';
  const WINDOW_SESSION_SELECTED_DAY = 'request.confirmed.selectedDay';
  const WINDOW_SESSION_SELECTED_PERIOD = 'request.confirmed.selectedPeriod';

  const clearRequestInSession = () => {
    if (
      getSessionStorageSelectedLocation() ||
      getSessionStorageSelectedRetailer() ||
      getSessionStorageSelectedDay() ||
      getSessionStorageSelectedPeriod()
    ) {
      const { resetRequestSelectionBoxes } = useRequestSelectionBoxes();
      resetRequestSelectionBoxes(true);
    }

    window.sessionStorage.removeItem(WINDOW_SESSION_SELECTED_LOCATION);
    window.sessionStorage.removeItem(WINDOW_SESSION_SELECTED_RETAILER);
    window.sessionStorage.removeItem(WINDOW_SESSION_SELECTED_DAY);
    window.sessionStorage.removeItem(WINDOW_SESSION_SELECTED_PERIOD);
  };

  const getSessionStorageSelectedLocation = (): LocationSuggestion | null => {
    const location = sessionStorage.getItem(WINDOW_SESSION_SELECTED_LOCATION);
    if (!location) return null;
    return JSON.parse(location);
  };

  const setSessionStorageSelectedLocation = (
    location: LocationSuggestion | null
  ) => {
    if (!location) {
      sessionStorage.removeItem(WINDOW_SESSION_SELECTED_LOCATION);
      return;
    }
    sessionStorage.setItem(
      WINDOW_SESSION_SELECTED_LOCATION,
      JSON.stringify(location)
    );
  };

  const getSessionStorageSelectedRetailer = (): string | null => {
    const retailer = sessionStorage.getItem(WINDOW_SESSION_SELECTED_RETAILER);
    if (!retailer) return null;
    return JSON.parse(retailer);
  };

  const setSessionStorageSelectedRetailer = (
    suggestion: LocationSuggestion | null
  ) => {
    if (!suggestion) {
      sessionStorage.removeItem(WINDOW_SESSION_SELECTED_RETAILER);
      return;
    }
    sessionStorage.setItem(
      WINDOW_SESSION_SELECTED_RETAILER,
      JSON.stringify(suggestion)
    );
  };

  const getSessionStorageSelectedDay = (): string | null => {
    const date = sessionStorage.getItem(WINDOW_SESSION_SELECTED_DAY);
    if (!date) return null;
    return date;
  };

  const setSessionStorageSelectedDay = (date: Date | null) => {
    if (!date) {
      sessionStorage.removeItem(WINDOW_SESSION_SELECTED_DAY);
      return;
    }
    sessionStorage.setItem(WINDOW_SESSION_SELECTED_DAY, date.toISOString());
  };

  const getSessionStorageSelectedPeriod = (): string | null => {
    const period = sessionStorage.getItem(WINDOW_SESSION_SELECTED_PERIOD);
    if (!period) return null;
    return period;
  };

  const setSessionStorageSelectedPeriod = (period: string | null) => {
    if (!period) {
      sessionStorage.removeItem(WINDOW_SESSION_SELECTED_PERIOD);
      return;
    }
    sessionStorage.setItem(WINDOW_SESSION_SELECTED_PERIOD, period);
  };

  window.addEventListener('beforeunload', () => clearRequestInSession());

  return {
    clearRequestInSession,
    getSessionStorageSelectedLocation,
    setSessionStorageSelectedLocation,
    getSessionStorageSelectedRetailer,
    setSessionStorageSelectedRetailer,
    getSessionStorageSelectedDay,
    setSessionStorageSelectedDay,
    getSessionStorageSelectedPeriod,
    setSessionStorageSelectedPeriod,
  };
};

export default useRequestSessionStorage;
